module.exports = __webpack_public_path__ + "static/media/travel-bg-left.f30b58e3.jpg";